import { Component, ContentChild, Input, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-toggle-view',
    templateUrl: './toggle-view.component.html',
    styleUrls: ['./toggle-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule, NgTemplateOutlet]
})
export class ToggleViewComponent {

    @Input() expanded = false;

    @ContentChild(TemplateRef) template: TemplateRef<any>;

    constructor() { }

}
